<div class="app-mat-contenteditable-text-area contenteditable-editor"
     [class.textarea]="multiline" contenteditable="true"
     [mention]="insertableValues" [mentionConfig]="mentionConfig" (itemSelected)="onItemSelect($event)"
     (focus)="onElementFocused()" (touchend)="onElementTouched()" (blur)="onElementBlur()"
     (input)="onElementInput($event)">
</div>
